export default __webpack_public_path__ + "static/breakdown-by-operating-system-light-mode-9922200b124162b27bbfc963d1594db6.png";